module.exports = {
    name: 'data',
    path: '/data',
    component: () => import('@data/Data'),
    meta: { module: "data" },
    children: [
        {
            path: '/',
            name: 'data_home',
            component: () => import ('@data/views/DataHome'),
            meta: { module: 'data' },
            children: [
                {
                    path: '/data/:exchangeId/report',
                    name: 'data_report',
                    component: () => import ('@data/components/DataReport'),
                    children: []
                },
            ]
        },
        {
            path: '/data/exchange/',
            name: 'data_exchange',
            component: () => import ('@data/views/DataExchange'),
            children: []
        },
        {
            path: '/data/settings/',
            name: 'data_settings',
            component: () => import ('@data/views/DataSettings'),
            children: []
        },
    ]
};
